module.exports = /*html*/ `
<div :class="dataIsLoad ? '' : 'loading'">
  <div id="size-report" class="modal fade" tabindex="-1">
    <div class="modal-dialog" role="document" style="max-width: 800px">
      <div class="modal-content">
        <div class="modal-header">
          <a href="#" data-dismiss="modal" class="r-lightbox__close"></a>
        </div>
        <div class="modal-body">
          <div v-html="itemDatas.SizeReport"></div>
        </div>
      </div>
    </div>
  </div>
  <div id="productArea">
    <div class="product-photos">
      <Photos v-if="isMobile" :photoCover="true" />
      <Photos v-else :photoCover="false" />
    </div>
    <div class="product-details">
      <WishlistBtn />
      <Price />
      <div class="product-color shop-product-color">
        <ColorButton />
        <span class="product-color__current">
          {{ selectedData.Name }}
        </span>
      </div>
      <SelectSize />
      <p
        v-if="selectedSpec.Stock < 10 && selectedSpec.Stock !== 0"
        class="sold-out-text"
      >
        即將售完
      </p>
      <Quantity />
      <div class="product-buttons" v-if="!isMobile">
        <BuyButton :buyNow="true" />
        <BuyButton :buyNow="false" />
      </div>
      <div v-if="selectedSpec.PreOrder">
        <div class="product-PreorderDAY">
          <span class="date">{{ itemDatas.ArrivalExplanation }}</span>
        </div>
      </div>
      <div
        v-if="itemDatas.GiftEvents || itemDatas.Limit !== 0"
        class="gift-event-block lh-15"
      >
        <div v-if="itemDatas.Limit !== 0" class="h6">
          此商品限購 {{ itemDatas.Limit }} 件
        </div>
        <div
          v-for="giftEvent in itemDatas.GiftEvents"
          :key="giftEvent.ID"
          class="h6"
        >
          <a :href="'/campaign/gift/' + giftEvent.ID">{{ giftEvent.Name }}</a>
        </div>
      </div>
      <div v-if="isMobile" id="bottom-bar">
        <a
          v-if="selectedSpec.Key === 'default'"
          href="#"
          :class="itemDatas.IsPreShow ? 'btn-secondary disabled' : ''"
          class="open-dialog btn-add-cart btn"
          data-dialog="#dialog-market"
          @click.prevent="showMobileCartDialog"
        >
          {{ itemDatas.IsPreShow ? "即將開賣" : "加入購物車" }}
        </a>
        <BuyButton v-else :buyNow="false" />
      </div>
      <div class="product-summary">
        <ul class="tabs__nav">
          <li>
            <a
              href="javascript:"
              @click="showProductInfo(0)"
              :class="{selected: summary === 0}"
              >商品資訊</a
            >
          </li>
          <li>
            <a
              href="javascript:"
              @click="showProductInfo(1)"
              :class="{selected: summary === 1}"
              >洗滌方式</a
            >
          </li>
          <li>
            <a href="javascript:" @click.prevent="openPopup">尺寸指南</a>
          </li>
        </ul>
        <div class="tabs__content">
          <div>
            <p>{{ itemDatas.SubTitle }}</p>
            <p class="mb-2" v-html="itemDatas.Description" />
            <p>*實品顏色依單品照為主</p>
            <p class="mb-2" v-html="itemDatas.MaterialDescription" />
            <p>{{ "素材產地 / " + itemDatas.MaterialOriginDescription }}</p>
            <p class="mb-2">
              {{ "加工產地 / " + itemDatas.OriginDescription }}
            </p>
            <div class="product-barcode mb-2">{{ selectedSpec.Barcode }}</div>
          </div>
          <div class="hide">
            <p v-html="itemDatas.CareLabelDesc" />
          </div>
          <div
            id="mobile-report-content"
            class="hide"
            v-if="isMobile"
            v-html="itemDatas.SizeReport"
          ></div>
        </div>
      </div>
      <Photos v-if="isMobile" :photoCover="false" />
      <Addon :marketID="CustomMarketID" />
      <ootd v-if="isMobile" class="position-relative" />
      <Recommend v-if="isMobile" />
    </div>
  </div>
  <ootd v-if="!isMobile" />
  <Recommend v-if="!isMobile" />
  <SpecMobile />
  <StockMobile v-if="isOpenStockDialog" />
  <Notice :custommarketid="CMID" />
  <AddToCart />
</div>
`;
